var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Timeouts } from './framework/Timeouts';
const keyboardControls = {
    back: 'Back',
    channelDown: 'Down',
    channelUp: 'Up',
    directionDown: 'Down',
    directionEnter: 'Select',
    directionLeft: 'Left',
    directionRight: 'Right',
    directionUp: 'Up',
    home: 'Home',
    info: 'Info',
    keyEnter: 'Enter',
    mediaPlayerForward: 'Fwd',
    mediaPlayerPause: 'Pause',
    mediaPlayerPlay: 'Play',
    mediaPlayerReverse: 'Rev',
};
export class Roku {
    constructor(http, state, log, framework) {
        this.http = http;
        this.state = state;
        this.log = log;
        this.mediaApps = [];
        this.timeouts = new Timeouts();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.channelKeyboardType = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () { return 'full'; }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const resp = yield this.httpRequest('get', 'query/device-info', tags);
                const fwRegEx = /software-version>(.+)<\/software-version/i;
                const match = fwRegEx.exec((_a = resp === null || resp === void 0 ? void 0 : resp.data) !== null && _a !== void 0 ? _a : '');
                return match ? match[1].trim() : 'unknown';
            }),
        };
        this.mediaOperation = {
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                var _b;
                if (value.operation === 'channelSet') {
                    // Channel favorites can be the unique provider id, i.e., 12, or the provider name,
                    // i.e., netflix. providerId is more robust as it is unique, but not everyone will
                    // know the provider id, so we support a string match on the provider name.
                    let app = this.mediaApps.find(myApp => myApp.providerId === value.channel);
                    if (app === undefined) {
                        app = this.mediaApps.find(myApp => myApp.name.toLowerCase().includes(value.channel.toLowerCase()));
                    }
                    if (app) {
                        yield this.httpRequest('post', `launch/${app.providerId}`);
                    }
                    else {
                        this.log.info(`Could not find app for ${value.channel}`);
                    }
                }
                else if (keyboardControls.hasOwnProperty(value.operation)) {
                    const operation = (_b = keyboardControls[value.operation]) !== null && _b !== void 0 ? _b : '';
                    yield this.httpRequest('post', `keypress/${operation}`);
                }
                else {
                    this.log.error(`unhandled media operation: ${value.operation}`);
                }
                return value;
            }),
        };
        this.mediaOperations = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                var _c, _d;
                const mediaOperationCaps = {};
                const mediaOperations = [
                    'back',
                    'channelSet',
                    'channelUpDown',
                    'directionUpDownLeftRight',
                    'directionEnter',
                    'home',
                    'info',
                    'mediaPlayerForward',
                    'mediaPlayerPause',
                    'mediaPlayerPlay',
                    'mediaPlayerReverse',
                ];
                for (const input of Object.values((_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.videoInputs) !== null && _d !== void 0 ? _d : {})) {
                    const tvTunerCode = '1';
                    if (input.code === tvTunerCode) {
                        mediaOperationCaps[input.code] = [...mediaOperations];
                    }
                }
                return mediaOperationCaps;
            }),
        };
        // polling
        this.polls = [
            {
                intervalMs: 10000,
                function: () => __awaiter(this, void 0, void 0, function* () {
                    yield this.httpRequest('get', 'query/media-player', ['poll']);
                }),
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            this.config = config;
            this.mediaApps.length = 0;
            const appRegEx = /id="(\d+)".+version="[^"]+">(.+)/i;
            const resp = yield this.httpRequest('get', 'query/apps', ['get-apps']);
            const apps = (_b = ((_a = resp === null || resp === void 0 ? void 0 : resp.data) !== null && _a !== void 0 ? _a : '').split('</app>')) !== null && _b !== void 0 ? _b : [];
            for (const app of apps) {
                const match = appRegEx.exec(app);
                if (match) {
                    this.mediaApps.push({ providerId: match[1], name: match[2] });
                }
            }
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.httpRequest('get', 'query/media-player', ['initialize']);
            if ((resp === null || resp === void 0 ? void 0 : resp.status) === 200) {
                return 'connected';
            }
            return 'verifyFailed';
        });
    }
    httpRequest(method, cmd, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = {};
            requestOptions.headers = {
                'Content-Type': 'application/json',
                Accept: '*/*',
                'Accept-Encoding': 'gzip, deflate, br',
            };
            requestOptions.tags = tags;
            const resp = yield this.http.request(method, `:8060/${cmd}`, requestOptions);
            return resp;
        });
    }
}
// static properties
Roku.driverType = 'httpDriver';
Roku.key = '-O6HYz2n-dDTo5GyjJlX';
Roku.httpRequestOptions = {
    scheme: 'http',
    idleTimeoutMs: 20000,
};
